export default {
    CountryDisplay: {
        DE: 'Deutschland',
        SG: 'Singapur',
        AT: 'Österreich',
        FR: 'Frankreich',
        CH: 'Schweiz',
        BE: 'Belgien',
        GB: 'Vereinigtes Königreich',
        NL: 'Niederlande',
        IT: 'Italien',
        ES: 'Spanien',
        CZ: 'Tschechische Republik',
    },
    SharedErrors: {
        UNKNOWN: 'Etwas ist schief gelaufen, bitte versuchen Sie es erneut.',
        VAT_EXEMPTION_NOT_ALLOWED_FOR_COMPANY:
            'Eine Firma in Deutschland sollte umsatzsteuerpflichtig sein.',
    },
    EditProfile: {
        edit1: 'Partnerdaten',
        edit2: 'bearbeiten',
        cancel: 'Abbrechen',
        userInfo: 'Vertragspartner',
        beneficiaryDescription:
            'Der Vertragspartner ist Begünstigter der Gutschriften.',
        billingAddress: 'Separater Gutschriftenempfänger',
        recipientContactDescription:
            'Sie können einen separaten Kontakt für den Erhalt der Gutschriften angeben. Der Vertragspartner bleibt Begünstigter der Gutschriften.',
        bank: 'Bankverbindung',
        saveSection: 'Speichern',
        contractDetails: 'Vertragsdaten',
        changedNote: 'Zuletzt geändert am %s',
    },
    TurnoverCard: {
        title: 'Abrechnungen',
        loading: 'Ihre Abrechnungen werden geladen...',
        noTurnover: 'Sie haben bisher keine Abrechnungen.',
    },
    TurnoverItem: {
        1: 'Januar',
        2: 'Februar',
        3: 'März',
        4: 'April',
        5: 'Mai',
        6: 'Juni',
        7: 'Juli',
        8: 'August',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'Dezember',
        corrected: 'korrigiert',
    },
    UsagePeriodsCard: {
        title: 'Nutzungsdaten',
        loading: 'Die Nutzungsdaten werden geladen...',
        noData: 'Es gibt bisher keine Nutzungsdaten.',
    },
    UsagePeriodItem: {
        month: 'Monat',
        cycles: 'Maschinenvorgänge',
        amount: 'Umsatz',
    },
    ProfileBillingDataForm: {
        title: 'Abrechnungsdetails',
        description:
            'Wir verwenden Ihre Bankdaten, um Ihren Umsatzanteil am Anfang des Monats zu überweisen.',
        errorLoading:
            'Etwas ging schief. Konnte die Abrechnungsdetails nicht finden.',
        accountholderName: 'Name des begünstigten Kontoinhabers*',
        accountholderNameError: 'Bitte geben Sie einen Namen an.',
        iban: 'IBAN*',
        ibanError: 'Bitte geben Sie eine korrekte IBAN an.',
        bic: 'BIC',
        bicHint: 'BIC wird automatisch befüllt falls nicht angegeben.',
        bicError: 'Bitte geben Sie eine korrekte BIC an.',
        useSettlement: 'Bankdaten',
        useEmail: 'Monatliches Gutschriftdokument per E-Mail erhalten',
        emailAddress: 'E-Mail-Adresse*',
        emailAddressError: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
        creditNotesEnabled: 'Gutschriften aktiviert',
    },
    ProfileContractDetailsForm: {
        company_registration_number: 'Handelsregisternummer',
        setDefaults: 'Default-Werte setzen',
        calculatedShare:
            'Daraus berechneter WeWash Turnover Anteil wg. Mehrwertsteuer:',
        vat_exempted: 'Dieser Verwaltungsbereich ist umsatzsteuerpflichtig.',
        vat_exemption_reason: 'Grund:',
        vat_id: 'USt-ID / Steuernummer*',
        vatError: 'Bitte geben Sie eine korrekte USt-ID / Steuernummer an',
        contractual_wewash_share: 'WeWash Turnover Anteil (laut Vertrag)',
        country_id: 'Land*',
        country_idError: 'Bitte wählen Sie ein Land aus.',
        contractual_type: 'Vertragstyp',
        tenant: 'Tenant',
        pmsProvider: 'Property Management System',
        generalError: 'Etwas ist schief gelaufen, bitte prüfen Sie Ihre Daten.',
        confirmContractualChangeTitle: 'Vertragstyp Ändern?',
        confirmContractualChangeText:
            'Hinweis: Diese Änderung betrifft alle Waschräume und Maschinen im Verwaltungsbereich.',
        confirmContractualChangeContinue: 'Vertragstyp ändern',
        confirmContractualChangeCancel: 'Abbrechen',
    },
    CancelContinueButtons: {
        cancel: 'Abbrechen',
        continue: 'Fortfahren',
    },
    LoginEntry: {
        message: {
            one: 'Du bist bereits als',
            two: 'eingeloggt.',
        },
        error: {
            UNKNOWN: 'Etwas ist schief gelaufen, bitte versuche es erneut.',
            USER: 'Bitte melden Sie sich mit Ihren WeWash-Partner-Accountdaten an!',
            BLOCKED:
                'Ihr Account ist vorübergehend deaktiviert. Kontaktieren Sie bitte den Kundenservice unter support@we-wash.com um den Account wieder freizuschalten.',
            LOGOUT: 'Bitte melden Sie sich erneut an.',
            WRONG_CREDENTIALS: 'Login-Daten ungültig.',
        },
        index: 'Zur Startseite',
        email: 'E-Mail',
        password: 'Passwort',
        login: 'Login',
        passwordReset: 'Passwort vergessen?',
        mainTitle: 'Zugangsdaten bestätigen',
    },
    Registration: {
        registrationTitle: 'Partner Registrierung',
        registrationPostit1:
            'Mit diesem Account können Sie ein oder mehrere Verwaltungsbereiche und Objekte managen. Die Daten für den ersten Verwaltungsbereich werden im Anschluss an die Registrierung und Aktivierung Ihres Accounts abgefragt.',
        skip: 'Überspringen',
    },
    RegistrationBasicForm: {
        title: 'Herzlich Willkommen bei WeWash!',
        description: 'Lieber WeWash-Partner,',
        description2:
            'bitte registrieren Sie sich nachfolgend mit Ihren Kontaktdaten und legen Sie die zukünftigen Zugangsdaten zum WeWash Partner Board fest.',
        registerLabel: 'Registrieren',
        language: 'Sprache*',
        languageGer: 'Deutsch',
        languageEng: 'Englisch',
        salutation: 'Anrede',
        salutationMr: 'Herr',
        salutationMrs: 'Frau',
        first_name: 'Vorname*',
        first_nameError: 'Bitte geben Sie einen Vornamen an.',
        last_name: 'Nachname*',
        last_nameError: 'Bitte geben Sie einen Nachnamen an.',
        company_name: 'Firmenname*',
        company_nameError: 'Bitte geben Sie einen Firmennamen an.',
        country_id: 'Land*',
        country_idError: 'Bitte wählen Sie ein Land aus.',
        phone: 'Telefon*',
        phoneError: 'Bitte geben Sie eine Telefonnummer an.',
        email: 'E-Mail*',
        emailError: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
        email_confirm: 'E-Mail Wiederholung*',
        email_confirmError:
            'Die E-Mail-Adressen unterscheiden sich. Bitte geben Sie die gleiche E-Mail-Adresse an.',
        email_confirmHelp:
            'Bitte geben Sie zur Bestätigung Ihre E-Mail-Adresse nochmals an.',
        termsAndCond1: 'Hiermit bestätige ich, dass ich die ',
        aGB: 'Nutzungsbedingungen',
        agbUrlRoute: '/nutzungsbedingungen',
        pp: 'Datenschutzerklärung',
        ppUrlRoute: '/datenschutz',
        and: ' und die ',
        termsAndCond2: ' gelesen und akzeptiert habe.',
        accept_agbError:
            'Bitte bestätigen Sie, dass Sie die Nutzungsbedingungen und die Datenschutzerklärung gelesen und akzeptiert haben.',
        vat_exempted: 'Dieser Verwaltungsbereich ist umsatzsteuerpflichtig.',
        vat_id: 'USt-ID / Steuernummer',
        vatError: 'Bitte geben Sie eine korrekte USt-ID /Steuernummer an',
        password: 'Passwort*',
        passwordError:
            'Bitte beachten Sie die Regeln für ein sicheres Passwort.',
        passwordHelp:
            'Das Passwort muss aus mind. 8 Zeichen inkl. mind. 1 Sonderzeichen und 1 Zahl bestehen.',
        password_confirm: 'Passwort Wiederholung*',
        password_confirmError:
            'Die Passwörter unterscheiden sich. Bitte geben Sie das gleiche Passwort an. ',
        generalError: 'Etwas ist schief gelaufen, bitte prüfen Sie Ihre Daten.',
        errorNotFullyFilled: 'Bitte füllen Sie alle Felder aus!',
        errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        errorPassword:
            'Das Passwort muss mindestens 8 Zeichen lang sein und mindestens 1 Sonderzeichen enhalten.',
        codeError: 'Der von Ihnen angegebene Aktivierungscode ist ungültig',
        duplicateUserAlert: 'E-Mail-Adresse bereits registriert',
        errorWrongActivation:
            'Der von Ihnen angegebene Aktivierungscode ist ungültig',
    },
    CreatePartnerBasicForm: {
        registrationTitle: 'Verwaltungsbereich anlegen',
        title: 'Vertragsdaten',
        descriptionInitialPartnerCreation:
            'Hier legen Sie Ihren Verwaltungsbereich an. Geben Sie hierzu einen Ansprechpartner sowie die Rechnungsdaten für die monatliche Umsatzbeteiligung an. Unter diesem Verwaltungsbereich können Sie später beliebig viele Objekte und Waschräume anlegen. Nach dem Login können darüber hinaus weitere Verwaltungsbereiche für zusätzliche Objekte mit individuellen Rechnungsdaten erstellt werden.',
        description:
            'Hier legen Sie Ihren neuen Verwaltungsbereich an. Geben Sie hierzu einen Ansprechpartner sowie die Rechnungsdaten für die monatliche Umsatzbeteiligung an. Unter diesem Verwaltungsbereich können Sie später beliebig viele Objekte und Waschräume anlegen.',
        cancel: 'Zurück',
        generalError: 'Etwas ist schief gelaufen, bitte prüfen Sie Ihre Daten.',
        contractualContactTitle: 'Vertragspartner',
        contractualContactDescription:
            'Bitte geben Sie hier die Adresse ein, an die zum einen die Rechnung für die WeWash Boxen versendet wird und die gleichzeitig für die Erstellung der monatlichen Gutschriften genutzt wird. ',
        billing_title: 'Abrechnungsdetails',
        billing_description:
            '<p>Bitte geben Sie hier die Bankverbindung an, an die Sie für diesen Verwaltungsbereich zukünftig die monatlichen Gutschriften von WeWash erhalten möchten. Diese errechnen sich durch:</p> <p>Anzahl Vorgänge * Preis pro Waschen / Trocknen <br/> – WeWash-Provision <br/>= Ihre Gutschriftsumme</p>',
        finish: 'Registrierung abschließen',
        accountholderName: 'Name des Kontoinhabers*',
        accountholderNameError: 'Bitte geben Sie einen Kontoinhaber an.',
        iban: 'IBAN*',
        ibanError: 'Bitte geben Sie eine gültige IBAN an.',
        bic: 'BIC',
        bicError: 'Bitte geben Sie einen gültigen BIC an.',
        postitTextInitialPartnerCreation:
            'Die Kontaktfelder sind mit Ihren angegebenen Daten bei Registrierung vorausgefüllt. Diese Angaben können Sie nach Bedarf bearbeiten.',
        postitText:
            'Unter einem Verwaltungsbereich können ein oder mehrere Objekte und Waschräume verwaltet werden, welche identische Ansprechpartner und Rechnungsdaten besitzen.',
        recipientContactTitle: 'Empfänger für Gutschriften',
        recipientContactDescription:
            'Sie können einen separaten Kontakt für den Erhalt der Gutschriften angeben. Der Vertragspartner bleibt Begünstigter der Gutschriften.',
        recipientContactDisabled:
            'Gutschriften werden an die Vertragspartneradresse geschickt.',
    },
    ProfileContactDataForm: {
        chooseToUse: 'Diese Kontaktdaten eingeben',
        phone: {
            label: 'Telefon',
            error: 'Bitte geben Sie eine Telefonnummer an.',
        },
        company: {
            label: 'Firmenname*',
            error: 'Bitte geben Sie einen Firmennamen an.',
        },
        supplementary_line1: { label: 'Adresszusatz', error: '' },
        supplementary_line2: { label: 'Adresszusatz 2', error: '' },
        supplementary_line3: { label: 'Adresszusatz 3', error: '' },
        name: { label: 'Name', error: '' },
        street_and_housenumber: {
            label: 'Straße und Hausnummer*',
            error: 'Bitte geben Sie eine Straße und Hausnummer an.',
        },
        city: { label: 'Ort*', error: 'Bitte geben Sie einen Ort an.' },
        postal_code: {
            label: 'Postleitzahl*',
            error: ' Bitte geben Sie eine korrekte Postleitzahl an.',
        },
        country: { label: 'Land*', error: 'Bitte wählen Sie ein Land aus.' },
        genericError: 'Etwas ist schief gelaufen, bitte prüfen Sie Ihre Daten.',
        comboboxHelp: {
            openCombobox: 'Aus der Liste wählen',
            emptyList: 'Lade...',
            emptyFilter:
                'Sie können einen Ländernamen frei eingeben, oder einen uns bekannten auswählen.',
        },
    },
    ContactAddressPreview: {
        description: 'Vorschau',
    },
    FieldContractualType: {
        RMS: 'RMS',
        ADMIN: '---',
        CITY_POP: 'City Pop',
        WWC: 'WeWash Care',
        WWB: 'WeWash Box',
        WWC_IDOS: 'WeWash Care i-Dos',
        WHITE_LABEL_WWB: 'White Label Service WWB',
        WHITE_LABEL_WWC: 'White Label Service WWC',
        WWC_MINIMUM_USAGE: 'WeWash Care mit Mindestnutzung',
        WWC_IDOS_MINIMUM_USAGE: 'WeWash Care mit Mindestnutzung inkl. idos',
    },
    FieldVatExemptionReason: {
        vat_id: 'USt-IdNr',
        tax_number: 'Steuernummer',
        no_number: 'Keine Angabe',
        vatError: 'Bitte geben Sie eine korrekte USt-IdNr oder Steuernummer an',
        byCountry: {
            DE: {
                SUBJECT_TO_VAT:
                    'Dieser Verwaltungsbereich ist umsatzsteuerpflichtig.',
                VAT_EXEMPT:
                    'Dieser Verwaltungsbereich ist nicht umsatzsteuerpflichtig z.B. aufgrund der Kleinunternehmerregelung (gem. §19UStG)',
                REVERSE_CHARGE:
                    'Dieser Verwaltungsbereich ist nicht umsatzsteuerpflichtig aufgrund der Steuerschuldnerschaft des Leistungsempfängers (vgl. §13b, Abs. 2, Nr 1 UStG)',
            },
        },
        default: {
            SUBJECT_TO_VAT:
                'Dieser Verwaltungsbereich ist umsatzsteuerpflichtig.',
            VAT_EXEMPT:
                'Dieser Verwaltungsbereich ist nicht umsatzsteuerpflichtig z.B. aufgrund der Kleinunternehmerregelung',
            REVERSE_CHARGE:
                'Dieser Verwaltungsbereich ist nicht umsatzsteuerpflichtig aufgrund der Steuerschuldnerschaft des Leistungsempfängers',
        },
        hintVerificationUnknown: '',
        hintVerificationPending: 'Prüfung der USt-IdNr läuft. Dieser Vorgang kann mehrere Minuten dauern.',
        hintVerificationTechnicalError:
            'Ein technischer Fehler hat verhindert, dass die USt-IdNr verifiziert werden konnte. WeWash kümmert sich darum.',
        hintVerificationSuccess: 'Die USt-IdNr wurde erfolgreich bestätigt.',
        hintVerificationConfirmed: 'Sie haben die USt-IdNr bestätigt.',
        hintVerificationNotChecked: 'USt-IdNr Verifizierung nicht notwendig.',
        hintVerificationFailure:
            'Die USt-IdNr konnte nicht bestätigt werden. Bitte kontrollieren Sie die Nummer und passen Sie diese gegebenenfalls an.',
        hintVerificationMismatchedCompanyName:
            'Die USt-IdNr konnte nicht bestätigt werden. Der Firmenname passt nicht zu "%s", den das VAT Information Exchange System zurückgegeben hat.',
        hintVerificationCompanyWithoutVat:
            'Rechtsformen wie GmbH oder AG sind in der Regel umsatzsteuerpflichtig. Bitte prüfen Sie Ihre Angaben noch einmal. Sie können diese mit "Angaben bestätigen" als korrekt markieren.',
        textVerificationConfirm: 'Alternativ:',
        actionVerificationConfirm: 'USt-IdNr bestätigen',
        actionVerificationConfirmCompany: 'Angaben bestätigen',
        actionRefresh: 'Status aktualisieren',
        modalConfirmText:
            'Die USt-IdNr konnte nicht bestätigt werden. In seltenen Fällen kann die Validierung über das VAT Information Exchange System fälschlicherweise fehlschlagen, obwohl die Daten korrekt sind. In diesem Fall können Sie die Daten als korrekt bestätigen.',
        modalConfirmTitle: 'USt-IdNr bestätigen?',
        modalConfirmConfirm: 'USt-IdNr bestätigen',
        modalConfirmReject: 'Abbrechen',
    },
    RegistrationActivationForm: {
        title: 'Konto aktivieren',
        description:
            'Bitte fügen Sie hier den Code ein, den Sie soeben per E-Mail erhalten haben. Sollten Sie keine E-Mail erhalten haben, prüfen Sie bitte Ihren Spam-Ordner. Gegebenenfalls schicken Sie bitte eine E-Mail an hilfe@we-wash.com',
        activate: 'Konto aktivieren',
        resendVerificationCode: 'Code erneut senden',
        codeSent: 'Code geschickt',
        activationCode: 'Aktivierungscode',
        activationCodeError:
            'Bitte geben Sie einen gültigen Validierungs-Code ein.',
        generalError: 'Etwas ist schief gelaufen, bitte prüfen Sie Ihre Daten.',
        errorNotFullyFilled: 'Bitte füllen Sie alle Felder aus!',
        errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        errorPassword:
            'Das Passwort muss mindestens 8 Zeichen lang sein und mindestens 1 Sonderzeichen enhalten.',
        codeError: 'Der von Ihnen angegebene Aktivierungscode ist ungültig',
        duplicateUserAlert: 'E-Mail-Adresse bereits registriert',
        errorWrongActivation:
            'Der von Ihnen angegebene Aktivierungscode ist ungültig',
    },
    LoginForm: {
        title1: 'Partner Login',
        title2: '',
        infoTitle: '',
        infoText:
            'Bitte melden Sie sich hier mit Ihrer E-Mail-Adresse und Ihrem Passwort an.',
    },
    Dashboard: {
        Postit3: {
            title: 'Partnerdaten unvollständig',
            text1: 'Bitte vervollständigen Sie Ihre Kontakt- und Bankdaten.',
            text2: 'Bitte vervollständigen Sie Ihre Bankdaten.',
            text3: 'Bitte vervollständigen Sie Ihre Kontaktdaten.',
        },
    },
    DashboardStatistics: {
        statistics1: 'Statistik über alle Objekte',
        statistics2: 'Laufender Monat',
        numberOfUsers: 'Nutzer',
        numberOfCycles: 'Maschinenvorgänge',
        wonThisMonth: 'Umsatz',
        goToDetails: 'Zur detaillierten Ansicht',
    },
    VerticalNavigation: {
        myTitle: 'Verwaltungsbereich',
        weWash: 'für',
        editPartnerData: 'Bereichsdaten',
        dashboard: 'Dashboard',
        payment: 'Abrechnungen',
        partnerInvoices: 'Rechnungen',
        objects: 'Objekte',
        roles: 'Zugriffsverwaltung',
        operationalContacts: 'Ansprechpartner',
        downloads: 'Downloads',
        customerId: 'Kundennr.:',
        usageData: 'Nutzungsdaten',
    },
    ObjectsOverview: {
        object: 'Objekt',
        objects: 'Objekte',
        turnover: 'Umsatz',
        numberOfUsers: 'Nutzer',
        numberLocations: 'Waschräume',
        numberOfOperationContacts: 'Ansprechpartner',
        addObject: 'Objekt hinzufügen',
        objectFilterHint: 'Filtern nach Strasse, PLZ oder Stadt',
    },
    ObjectStatisticsCard: {
        title: 'Statistik des Objekts ',
        title2: 'Laufender Monat',
        numberOfUsers: 'Nutzer',
        numberOfCycles: 'Maschinenvorgänge',
        wonThisMonth: 'Umsatz',
    },
    ObjectStatistics: {
        turnover: 'Umsatz in diesem Monat',
        users: 'Nutzer in diesem Monat',
    },
    ObjectsDetails: {
        locations: 'Waschräume',
        editObject: 'Objekt bearbeiten',
        location: 'Waschraum',
        numberOfAppliances: 'Anzahl Maschinen',
        addLocation: 'Waschraum hinzufügen',
        warnOperationalContactsText:
            'Bitte hinterlegen Sie für jedes Ihrer Objekte einen operativen Ansprechpartner. Diesen kontaktieren wir bei operativen Themen, z.B. wenn eine Maschine gewartet werden muss.',
        warnOperationalContactsButton: 'Ansprechpartner hinzufügen',
    },
    Navigation: {
        myWeWash: 'Dashboard',
        help: 'Hilfe',
        contact: 'Kontakt',
        logout: 'Ausloggen',
        selectPartner: 'Bereichsübersicht',
        partnerManagerAccount: 'Account verwalten',
    },
    Footer: {
        imprint: 'Impressum',
        data: 'Datenschutz',
        imprintLink: 'https://www.we-wash.com/impressum',
        privacyPolicyLink: 'https://www.we-wash.com/datenschutz',
    },
    Content: {
        all: 'Alle',
        elements: 'Elemente',
        open: 'Öffnen',
        register: 'Registrierungs',
        process: 'prozess',
        to: 'Zum',
        dashboard: 'Dashboard',
    },
    General: {
        save: 'Speichern',
        remove: 'Remove',
        cancel: 'Abbrechen',
        edit: 'Bearbeiten',
        didYouKnow: 'Wussten Sie schon?',
        refresh: 'Aktualisieren',
    },
    Breadcrumbs: {
        startPage: 'Startseite',
        objects: 'Meine Objekte',
        'create-object': 'Objekt anlegen',
        'create-location': 'Waschraum anlegen',
        'create-appliance': 'Maschine hinzufügen',
        profile: 'Partnerdaten bearbeiten',
        turnover: 'Umsätze',
        '/help': 'Hilfe',
        overview: 'Bearbeiten',
        password: '1. Kennwort ',
        partner: '2. Ansprechpartner ',
        address: '3. Rechnungsadresse',
        bank: '4. Bankverbindung für diesen Verwaltungsbereich',
        vip: 'Preise verwalten',
        selectLocationPricing: 'Waschraumauswahl für Preisänderung',
    },
    CreateAppliance: {
        add1: 'Maschine',
        add2: 'hinzufügen',
        headline: 'Informationen über die Maschine',
        description: '',
        cancel: 'Abbrechen',
        save: 'Maschine hinzufügen',
        Postit1: {
            text1: 'Geben Sie hier bitte an:',
            text2: 'Beschreibung: Wir empfehlen die Maschine mit der Herstellerbezeichnung zu benennen (z.B. Bosch HomeProfessional WTY87641CH).',
            text3: 'Wählen Sie den Maschinentyp.',
            text4: 'Übertragen Sie die Seriennummer (W4CDLXXX) und die zugewiesene Kurzbezeichnung (W1, T1).',
            text5: 'Die Seriennummer befindet sich an jeder Box an der linken Seite über dem Barcode.',
        },
        generalError: 'Fehler beim Anlegen der Maschine.',
    },
    EditAppliance: {
        delete: 'Löschen',
        headline: 'Informationen über die Maschine',
        description: '',
        cancel: 'Abbrechen',
        saveSection: 'Speichern',
        status_title: 'Status der Maschine',
        installationVerificationTitle: 'Test-Zyklus',
        statusPostit: {
            title: 'Status',
            text1: 'Nutzungsstatus: Zeigt an, ob die Maschine in der Nutzer-App als verfügbar angezeigt wird.',
            text2: 'Operativer Status: Zeigt an, ob die Maschine aktiviert, für die Wartung deaktiviert ist oder sich in einem Test-Zyklus befindet.',
        },
        verificationCyclePostit: {
            title: 'Test-Zyklus',
            text: 'Mit Anforderung des Test-Zyklus wird die Maschine sofort für App-Buchungen deaktiviert. Zeitgleich wird die Maschine innerhalb weniger Minuten automatisch freigeschaltet, sodass ein Test-Zyklus innerhalb von 16 h im Waschraum gestartet werden kann. Nach erfolgreichem / abgelaufenem Test-Zyklus wird die Maschine aktiviert.',
        },
        deleteModal: {
            title: 'Maschine Löschen?',
            description:
                'Löschen der Maschine beendet die Nutzung dieser Maschine via WeWash. Danach können Sie die WeWash Box verwenden, um eine neue Maschine anzuschließen.',
            confirm: 'Löschen',
            cancel: 'Abbrechen',
        },
    },
    ApplianceBasicForm: {
        local_name: 'Beschreibung (Hersteller, Modell)*',
        local_name_error: 'Bitte geben Sie eine Beschreibung an.',
        short_name: 'Kurzbezeichnung*',
        short_name_default: '...',
        short_name_error: 'Bitte weisen Sie eine Kurzbezeichnung zu.',
        short_name_duplicate_error:
            'Diese Kurzbezeichnung ist bereits einer anderen Maschine zugewiesen.',
        appliance_type: 'Maschinentyp*',
        appliance_type_error: 'Maschinentyp bitte auswählen.',
        type_w: 'Waschmaschine',
        type_d: 'Trockner',
        contractual_type: 'Vertragstyp',
        serial_number: 'WeWash Box Seriennummer*',
        serial_number_input_error: 'Ungültige Seriennummer',
        serial_number_input_hint: 'Bitte geben Sie eine Seriennummer ein',
        connected: '(Verbunden)',
        inputVib: 'WeWash Artikelnummer',
        inputVibBadMatch: 'Artikelnummer passt nicht zum Maschinentyp.',
        optionUnknownVib: '(Unbekannt/Keine Artikelnummer)',
        inputManufacturingBatch: 'Batchnummer',
        inputModelGroup: 'Modellgruppe*',
        inputModelGroupBadMatch: 'Modellgruppe passt nicht zum Maschinentyp',
        controlType: 'Anschlussart der Maschine',
        signalType: 'Gerätesteuerung über Kassiergeräteanschluss (empfohlen)',
        powerType:
            'Gerätesteuerung über Versorgungsspannung (max. 16A pro Phase)',
        controlTypes: {
            POWER: {
                title: 'Haushaltsähnliche Geräte, die zum Öffnen der Tür keinen Strom benötigen',
                descriptions: [
                    'WeWash Box trennt das Stromnetz nach Zyklusende',
                    'Beispiele: Electrolux myPRO, alle anderen Haushaltsgeräte ohne Bezahlschnittstelle',
                ],
            },
            POWER_CONSTANT: {
                title: 'Haushaltsähnliche Geräte, die zum Öffnen der Tür Strom benötigen',
                descriptions: [
                    'Die WeWash Box hält die Netzverbindung nach dem Ende des Zyklus aufrecht, um das Öffnen der Tür zu ermöglichen',
                    'Nur bestimmte Miele Professional SmartBiz und Miele Domestic-Waschmaschinen benötigen diese Einstellung',
                ],
            },
            PAYMENT_SIGNAL: {
                title: 'Electrolux Professional ohne I/O-Karte',
                descriptions: [
                    'Gepulstes, einmaliges Signal (z.B. 0,5s Länge)',
                ],
            },
            PAYMENT_SIGNAL_FULL_DURATION: {
                title: 'Miele Professional im Zeitbetrieb (Time Mode)',
                descriptions: [
                    'Signal bis Zyklusende',
                    'Andere Marken: Electrolux Professional mit I/O-Karte und der entsprechenden Einstellung',
                ],
            },
            PAYMENT_SIGNAL_DURING_LOADING: {
                title: 'Miele Professional im Programmbetrieb',
                descriptions: [
                    'Signal bis zum Zyklusstart',
                    'Typische Einstellung, wenn das Gerät bereits mit einem Münz-/Jetonautomaten betrieben wurde',
                    'Andere Marken: IPSO, Primus, Huebsch',
                ],
            },
        },
        professionalApplianceHeader: 'Professional Maschine',
        professionalApplianceLabel:
            'Ist die Maschine eine Professional Maschine im Programmmodus?',
        constantPowerSupplyHeader: 'Elektrische Türöffnung',
        constantPowerSupplyLabel:
            'Benötigt diese Maschine Strom zum Öffnen der Tür (z.B. Miele Waschmaschinen, Ausnahme: Miele Professionals die über den Kassiergeräteanschluss angeschlossen wurden)?',
        typeWLabel: 'W',
        typeTLabel: 'T',
        errorTags: {
            UNDEFINED: 'Maschine konnte nicht hinzugefügt werden.',
            SERIALNUMBER_ALREADY_ASSIGNED:
                'Diese Seriennummer ist bereits vergeben.',
            LOCATION_ALREADY_HAS_ONE_HUB_SERIAL_NUMBER:
                'Der Waschraum hat bereits eine Hub-Serienummer.',
            SERIALNUMBER_UNAVAILABLE: 'Diese Seriennummer existiert nicht',
        },
        filterPlaceholder: 'Auswahl eingrenzen',
    },
    ApplianceStatusForm: {
        state: 'Nutzungsstatus',
        disabled: 'Nicht verfügbar',
        applianceState: {
            IDLE: 'Betriebsbereit',
            RESERVED: 'In Benutzung',
            READY_FOR_USE: 'In Benutzung',
            ACTIVE: 'In Benutzung',
            COMPLETE: 'In Benutzung',
            POWER_OFF: 'Betriebsbereit',
        },
        operationalStateLabel: 'Operativer Status',
        operationalState: {
            OPERATIONAL: 'Aktiviert',
            NON_OPERATIONAL: 'Deaktiviert für Wartung',
            INSTALLATION_VERIFICATION: 'Test-Zyklus aktiviert',
            BLIND_MAINTENANCE: 'Deaktiviert für Wartung',
            CLIENT_INSTALLATION: 'Deaktiviert für Wartung',
            NOT_CONFIGURED: 'Keine Verbindung / Ungültige Seriennummer',
        },
        generalError:
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später nochmal.',
    },
    InstallationVerificationForm: {
        statusLabel: 'Status',
        status: {
            IN_PREPARATION: 'Angefordert',
            LOADING_PHASE: 'Maschine kann gestartet werden',
            LOADING_PHASE_CANCEL_REQUESTED: 'Abbruch angefordert',
            APPLIANCE_RUNNING: 'Maschine läuft',
            PICKUP_PHASE: 'Daten werden ausgewertet',
            CANCELED: 'Abgebrochen',
            SUCCESS: 'Erfolgreich',
            FAILURE: 'Fehlgeschlagen',
            EXPIRED: 'Abgelaufen',
        },
        requestTime: 'Zeitpunkt letzter Test-Zyklus',
        startVerification: 'Test-Zyklus anfordern',
        cancelVerification: 'Test-Zyklus abbrechen',
        generalError:
            'Etwas ist schief gelaufen. Bitte aktualisieren Sie und versuchen es erneut.',
        cycleAlreadyStarted:
            'Abbrechen nicht mehr möglich. Die Maschine wurde bereits gestartet.',
        verificationAlreadyFinished: 'Der Test-Zyklus ist schon abgeschlossen.',
        verificationNotFinished:
            'Der vorherige Test-Zyklus ist noch nicht abgeschlossen.',
        verificationNotAllowedDuringMaintenance:
            'Test-Zyklus nicht möglich während der Wartung.',
    },
    Popup: {
        contact: {
            title: 'Kontakt',
            callUs: 'Rufen Sie uns an',
            email: 'E-Mail',
        },
        help: {
            title: 'Hilfe',
            text1: 'So erreichen Sie uns wenn Sie Hilfe benötigen:',
            emailtitle: 'E-Mail',
            email: 'hilfe@we-wash.com',
            phonetitle: 'Service - Telefon',
            phone: '+49 89 740 55 44 00',
        },
    },
    CreateObject: {
        add1: 'Objekt',
        add2: 'hinzufügen',
        cancel: 'Zurück',
        delete: 'Löschen',
        address: 'Adresse des Objekts',
        info: 'Informationen über das Objekt (optional)',
        management: 'Verwaltung des Objekts',
        text1: 'Das Hinzufügen eines Objekts ist denkbar einfach:',
        text2: 'Geben Sie die Adresse des gewünschten Objekts ein',
        text3: 'Zur optimalen Ausstattung Ihrer Waschräume geben Sie bitte noch einige Zusatz-Informationen zum Objekt an.',
        createObject: 'Objekt anlegen',
        saveSection: 'Speichern',
        Postit1: {
            title: 'Adresse',
            text1: 'Geben Sie hier bitte die vollständige Adresse Ihres Objekts an. Felder ohne * sind optional und müssen nicht ausgefüllt werden.',
        },
        Postit2: {
            text1: 'Um die optimale Ausstattung Ihres Objekts zu gewährleisten, helfen Sie uns bitte mit Angaben zum Objekttyp, der Gesamtanzahl der Maschinen und Wohneinheiten.',
        },
        operationalContactsTitle: 'Ansprechpartner',
    },
    EditObject: {
        edit1: 'Objekt',
        edit2: 'bearbeiten',
        cancel: 'Zurück',
        delete: 'Objekt löschen',
        address: 'Adresse des Objekts',
        info: 'Informationen über das Objekt',
        management: 'Verwaltung des Objekts',
        saveSection: 'Speichern',
        generalError:
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später nochmal.',
        locationExist:
            'Das Objekt enthält noch Waschräume und / oder offene Umsätze für den aktuellen Monat. Bitte entfernen Sie alle Waschräume aus dem Objekt und warten Sie bis zum nächsten Abrechnungsmonat.',
        locationHasCreditNotes:
            'Das Objekt enthält noch Waschräume und / oder offene Umsätze für den aktuellen Monat. Bitte entfernen Sie alle Waschräume aus dem Objekt und warten Sie bis zum nächsten Abrechnungsmonat.',
        deleteModal: {
            title: 'Objekt Löschen?',
            description:
                'Wenn Sie das Objekt löschen, sammeln wir keine Einkünfte aus dem Objekt mehr.',
            confirm: 'Löschen',
            cancel: 'Abbrechen',
        },
    },
    ObjectAddressForm: {
        street: 'Straße*',
        streetError: 'Bitte geben Sie eine Straße an.',
        city: 'Ort*',
        cityError: 'Bitte geben Sie einen Ort an.',
        description: 'Adresszusatz',
        postalcode: 'Postleitzahl*',
        postalcodeError: 'Bitte geben Sie eine korrekte Postleitzahl an.',
        country_id: 'Land*',
        country_idError: 'Bitte geben Sie ein richtiges Land an',
        housenumber: 'Hausnummer*',
        housenumberError: 'Bitte geben Sie eine Hausnummer an.',
        propagateChangesToLocations:
            'Adressänderungen an alle zu diesem Objekt dazugehörigen Waschräume weiterleiten',
    },
    ObjectInfoForm: {
        mansion_type: 'Objekttyp',
        num_of_machines: 'Anzahl Maschinen',
        num_of_machinesError:
            'Bitte geben Sie eine korrekte Anzahl der Maschinen an',
        housing_units: 'Wohneinheiten',
        housing_unitsError: 'Bitte geben Sie eine Anzahl der Wohneinheiten an',
        choose: 'Bitte wählen',
        optionMultiFamilyHouse: 'Mehrfamilienhaus',
        optionStudentHousing: 'Studentenwohnheim',
        optionCampsite: 'Campingplatz',
        optionClinic: 'Klinik',
        optionServicedApartment: 'Serviced Apartment',
        optionMicroLiving: 'Mikrowohnen',
        optionSeniorLiving: 'Seniorenwohnen',
        optionOtherNotKnown: 'Andere / Nicht bekannt',
        optionHostel: 'Hostel',
        optionHotel: 'Hotel',
        optionStaffHousing: 'Mitarbeiterwohnen',
        optionTruckStop: 'Rasthof',
        optionVacationApartment: 'Ferienwohnung / Ferienhaus',
        optionFittersFlat: 'Monteurswohnung',
        optionPublicLaundrette: 'Öffentlicher Waschsalon',
        alert: 'Anzahl der Maschinen in Ihrem Objekt',
    },
    LocationPositionForm: {
        details:
            'Verschieben Sie die Karte, um den Pin an der richtigen Stelle zu platzieren.',
        invalidTimezoneError:
            'Der Pin befindet sich außerhalb unseres Geschäftsbereiches.',
    },
    CreateLocation: {
        create1: 'Waschraum',
        create2: 'anlegen',
        location: 'Standort festlegen',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        price: 'Preise für Waschraum festlegen',
        createLocation: 'Waschraum anlegen',

        Postit1: {
            title: 'Waschraum anlegen',
            text1: 'Geben Sie dem Waschraum eine Bezeichnung. Diese Bezeichnung sollte selbstsprechend und leicht verständlich sein, da der Nutzer den Waschraum nach Ihrer Bezeichnung auswählt (z.B. Waschraum 5. Stock)',
            text2: 'Optional können Sie angeben, wie viele Wohneinheiten auf welche Anzahl von Maschinen zugreifen können.',
            buttonText: 'Unverbindlich Anfragen',
        },
        Postit2: {
            title: 'Preise festlegen',
            text1: 'Legen Sie hier den Preis pro Wasch- und Trockenvorgang fest. Dieser Betrag wird dem Nutzer bei Start des Vorgangs berechnet und Ihnen abzüglich unserer Provision gutgeschrieben.',
            text2: 'Das Feld Nutzerhinweis wird den Web-App Nutzern angezeigt. Sie können hier z.B. Angaben zu Nutzungszeiten des Waschraums geben.',
        },
    },
    EditLocation: {
        create1: 'Waschraum',
        create2: '',
        location: 'Standort festlegen',
        cancel: 'Zurück',
        delete: 'Löschen',
        note: 'Nutzerhinweis',
        saveSection: 'Speichern',
        generalError:
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später nochmal.',
        applianceExistError:
            'Im Waschraum sind noch Maschinen angelegt. Bitte entfernen Sie diese zuerst.',
        errorTags: {
            UNKNOWN: 'Der Waschraum konnte nicht gespeichert werden.',
            LOCATION_ALREADY_EXISTS:
                'Diese Bezeichnung wird bereits für einen anderen Waschraum in diesem Objekt verwendet.',
            INPUT_TOO_LONG: 'Nutzerhinweis zu lang.',
            SERIALNUMBER_IN_USE:
                'Seriennummer kann nicht geändert werden, weil sie auch von einer Maschine verwendet wird.',
        },
        deleteModal: {
            title: 'Waschraum Löschen?',
            description:
                'Sie können den Waschraum nur löschen wenn er keine Maschinen enthält.',
            confirm: 'Löschen',
            cancel: 'Abbrechen',
        },
    },
    LocationCostsForm: {
        note: 'Nutzerhinweis (optional)',
        note_notif: 'Das sehen Ihre Nutzer in der WeWash App.',
        note_error: 'Nutzerhinweis sollte nicht länger als 250 Zeichen sein.',
        washer_cost: 'Preis für Waschen* (in %s)',
        dryer_cost: 'Preis für Trocknen* (in %s)',
        washer_cost_error: 'Bitte geben Sie einen Preis an.',
        dryer_cost_error:
            'Sollten Sie keinen Trockner anbieten, schreiben Sie 0 in das Preisfeld.',
        cost_calculator_action:
            'Wir bieten Ihnen eine Hilfestellung zum Festlegen der Preise an. Klicken Sie hier um zum Nutzungspreis-Kalkulator zu kommen.',
        cost_calculator_link: 'https://we-wash.com/nutzungspreiskalkulator/',
    },
    LocationBasicForm: {
        name: 'Bezeichnung des Waschraums*',
        num_of_appartments:
            'Wie viele Wohneinheiten können diesen Waschraum nutzen?',
        reservation_minutes: 'Reservierungszeit',
        pickup_minutes: 'Abholzeit',
        booking_minutes: 'Buchungszeit',
        booking_logic: 'Welche Buchungslogik verwendet dieser Waschraum?',
        name_error: 'Bitte geben Sie eine Bezeichnung an.',
        name_duplicate_error:
            'Dieser Name wird bereits für einen anderen Waschraum in diesem Objekt verwendet.',
        num_of_appartments_error: 'Bitte geben Sie eine Zahl an.',
        reservation_minutes_error: 'Bitte geben Sie eine Reservierungszeit an.',
        pickup_minutes_error: 'Bitte geben Sie eine Abholzeit an.',
        minutes: ' Minuten',
        time_label:
            'Wie lange dürfen Nutzer Maschinen reservieren bzw. die Wäsche abholen?',
        time_label_with_user_direct_booking:
            'Wie lange dürfen Nutzer Maschinen reservieren? Wie viel Zeit haben sie, die Wäsche abzuholen?',
        time_label_for_booking_time:
            'Wie viel Zeit haben sie, die Maschine zu laden?',
        bookingLogicEnum: {
            USER_DIRECT_BOOKING: 'User Direct Booking',
            APPLIANCE_START: 'Appliance Start',
            CALENDAR: 'Waschkalender',
        },
        gateway_serial_number_input_error: 'Ungültige Seriennummer',
        gateway_serial_number_input_hint:
            'Bitte geben Sie eine Seriennummer ein',
        gateway_serial_number_dropdown: 'Seriennummer des Hubs',
        gateway_serial_number_help:
            "Der 'Hub' ist die WeWash Box mit dem Antennenanschluss an der Oberseite. Er gewährleistet den Empfang der WeWash Boxen im Waschraum. Sie können die Seriennummer auch erst später während der Installation hinzufügen.",
        optional: '(optional)',
        connected: '(Verbunden)',
    },
    VipUserPricing: {
        title: 'Preise verwalten',
        cancel: 'Zurück',
    },
    VipAddUserCard: {
        title: 'Nutzer für reduzierte Preise freischalten',
        submit: 'Nutzer freischalten',
        infoText:
            'Fügen Sie neue Nutzer anhand der Kundennummer / Customer ID hinzu.',
        explanation:
            'Fügen Sie neue Nutzer anhand der Kundennummer / Customer ID hinzu. Mehrere Nutzer können zusammen in das Feld eingegeben werden. Z.B. 123456789, 123456780, 123456786',
        newEntriesLabel: 'Kundennummer(n)',
        errors: {
            DUPLICATE_ENTRIES: 'Ihre Eingabe enthält Duplikate.',
            OTHER_ERROR: 'Unbekannter Fehler',
            UNKNOWN_USER: 'Kundennummer nicht bekannt',
        },
        reportTitle: 'Report',
        closeReport: 'Schließen',
        successfulSummary: '%s Nutzer wurden erfolgreich hinzugefügt.',
        alreadyExistsSummary: '%s Nutzer waren bereits hinzugefügt.',
        errorSummary: 'Folgende Nutzer konnten nicht hinzugefügt werden:',
    },
    FrequentActionCard: {
        title: 'Schnellzugriff',
        setPricesAction: 'Preise verwalten',
        addBankDataAction: 'Bankdaten angeben',
    },
    HighlightedActions: {
        priceSuggestionText:
            'Wir empfehlen Ihnen die Nutzungspreise anzupassen.',
        priceSuggestionAction: 'Vorgeschlagene Preisänderung ansehen',
        addBankDataText:
            'Um Ihren Umsatzanteil zu erhalten, benötigen wir Abrechnungsdetails von Ihnen.',
        addBankDataAction: 'Daten hinzufügen',
        addressVatinText:
            'Die USt-IdNr konnte nicht bestätigt werden. Bitte prüfen Sie Ihre USt-IdNr.',
        addressVatinAction: 'Prüfen',
        addOperationalContactsText:
            'Bitte hinterlegen Sie für jedes Ihrer Objekte einen operativen Ansprechpartner. Diesen kontaktieren wir bei operativen Themen, z.B. wenn eine Maschine gewartet werden muss.',
        addOperationalContactsAction: 'Ansprechpartner zuweisen',
    },
    VipSelectLocationCard: {
        locationName: 'Waschraum',
        locationAddress: 'Adresse',
        title: 'Reduzierte Preise',
        back: 'Zurück',
        explanation:
            'In welchem Waschraum wollen Sie die reduzierte Preise konfigurieren?',
        loading: 'Waschräume werden geladen...',
        empty: 'Noch keine Waschräume angelegt.',
    },
    LocationsDetails: {
        propertyLink: 'Property Link',
        connectivity: 'Konnektivität',
        vipUserPricingButton: 'Preise verwalten',
        connectivityStateLabel: 'Status',
        connectivityState: {
            INITIAL: 'Ungeprüft',
            UP: 'Verbunden',
            DOWN: 'Getrennt (< 15 Min.)',
            WARNING: 'Getrennt (< 60 Min.)',
            CRITICAL: 'Getrennt (> 60 Min.)',
            null: 'Ungeprüft',
            undefined: 'Ungeprüft',
        },
        connectivityCheckStateLabel: 'Prüfung',
        connectivityCheckState: {
            NONE: 'Nicht angefordert',
            REQUIRED: 'Angefordert',
            IN_PROGRESS: 'Wird durchgeführt',
        },
        connectivityCheckUpdateTime: 'Zeitpunkt letzte Prüfung',
        requestConnectivityCheck: 'Konnektivität prüfen',
        generalError:
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später nochmal.',
        add1: 'Maschine',
        add2: 'hinzufügen',
        cancel: 'Abbrechen',
        settings: 'Einstellungen',
        edit: 'Zu Waschraumdetails',
        description: 'Beschreibung',
        shortText: 'Kurzbezeichnung',
        serialNumber: 'WeWash Box Seriennummer',
        note: 'Notiz',
        appliances: 'Maschinen',
        typeWLabel: 'W',
        typeDLabel: 'T',
        disabled: 'deaktiviert',
        hotelCode: 'Hotel Code',
        Postit1: {
            title: 'Der Waschraum',
            text1: 'Diese Seite bietet eine Übersicht über Ihren ausgewählten Waschraum. Sie können hier:',
            text2: 'Neue Maschinen hinzufügen',
            text3: 'Angelegte Maschinen einsehen und bearbeiten',
            text4: 'Den Waschraum bearbeiten',
        },
        connectivityPostit: {
            title: 'Bei Installation beachten',
            text: 'Vergewissern Sie sich, dass die Seriennummer korrekt ist und prüfen Sie bei Neuinstallationen die Konnektivität. Insbesondere im Status „Ungeprüft“.',
        },
        managePricing: 'Preise verwalten',
        prices: 'Aktuelle Preise',
        washing: 'Waschen',
        drying: 'Trocknen',
        phoneUserPostit: {
            title: 'Waschraum-Telefon',
            usageNote:
                'Telefonnutzer können diese Nummer anrufen, um eine Waschmaschine oder einen Trockner zu buchen.',
            ratesNote: '* Zum Ortstarif; Mobilfunktarife können abweichen.',
            unknownPhoneNumber: 'n/a',
        },
    },
    InstallationLinkCard: {
        title: 'Installation',
        description:
            'Mit einem Installations-Link kann der Waschraum vor Ort eingerichtet werden. Der Link kann weitergeteilt werden, und ist auch ohne Account nutzbar.',
        installationLink: 'Installationslink',
        technicianBoardLinkPre: 'Zum',
        technicianBoardLinkText: 'Techniker Board',
        day: 'Tag',
        days: 'Tagen',
        createAction: 'Link erstellen',
        modalClose: 'Abbrechen',
        expires: 'Läuft ab in',
        invalid: 'Abgelaufen',
        emailAction: 'Per E-Mail senden',
        emailSuccess: 'Gesendet an',
        extendAction: 'Verlängern',
        revokeAction: 'Entfernen',
        revokeConfirmTitle: 'Installation Link entfernen',
        revokeConfirmMessage:
            'Sind Sie sicher, dass Sie den Installation Link entfernen möchten?',
        emailTitle: 'E-Mail mit Link versenden',
        emailMessage:
            'Wir senden den Installation Link an einen Techniker. Die E-Mail enthält die Waschraumnummer, einschließlich der Adresse. Mit dem in der E-Mail bereitgestellten Link können Techniker die Geräte in Ihrer Waschraumnummer einrichten und konfigurieren.',
        recipientLabel: 'Empfänger',
        recipientInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    },
    OrderPostit: {
        title: 'WeWash Boxen bestellen',
        text: 'Um WeWash Boxen zu bestellen, hinterlassen Sie uns hier eine Nachricht mit der Anzahl Ihrer Maschinen. Wir melden uns umgehend und klären die Details mit Ihnen.',
        messageLabel: 'Ihre Nachricht',
        message_error: 'Bitte schreiben Sie eine Nachricht',
        buttonLabel: 'Unverbindlich Anfragen',
        confirmationText:
            'Vielen Dank für Ihre Anfrage. Wir melden uns umgehend bei Ihnen.',
    },

    PasswordResetRequest: {
        resetMessage:
            'Bitte geben Sie die E-Mail-Adresse ein, mit der Sie sich registriert haben, um Ihr Passwort zurückzusetzen.',
        email: 'E-Mail',
        submit: 'Passwort zurücksetzen',
        login: 'Zurück zum Login',
        title: 'Passwort zurücksetzen',
        invalidEmail: 'Bitte gültige E-Mail-Adresse eingeben!',
        emailSentPreEmail:
            'Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts an ',
        emailSentPostEmail:
            ' gesendet. Bitte folgen Sie den Anweisungen in der E-Mail. Sollten Sie keine E-Mail erhalten haben, prüfen Sie bitte Ihre Eingabe.',
    },
    PasswordResetWrapper: {
        title: 'Passwort zurücksetzen',
    },
    PasswordResetForm: {
        badKey: 'Der Link zum Zurücksetzen des Passworts ist nicht mehr gültig. Bitte fordern Sie eine weitere E-Mail zum Zurücksetzen des Passworts auf der Anmeldeseite an.',
        resetMessage:
            'Bitte geben Sie Ihr neues Passwort ein, um Ihr Passwort zurückzusetzen.',
        email: 'E-Mail',
        confirmCode: 'Validierungscode',
        submit: 'Passwort zurücksetzen',
        login: 'Zurück zum Login',
        success:
            'Ihr Password wurde erfolgreich zurückgesetzt. Sie können sich nun mit Ihrem neuen Passwort einloggen.',
        title: 'Passwort zurücksetzen',
        invalidEmail: 'Bitte gültige E-Mail-Adresse eingeben!',
        password: 'Passwort',
        passwordError:
            'Bitte beachten Sie die Regeln für ein sicheres Passwort.',
        passwordHelp:
            'Das Passwort muss aus mind. 8 Zeichen inkl. mind. 1 Sonderzeichen und 1 Zahl bestehen.',
        passwordConfirm: 'Passwort Wiederholung',
        passwordConfirmError:
            'Die Passwörter unterscheiden sich. Bitte geben Sie das gleiche Passwort an. ',
    },
    PriceFormat: {
        language: 'de',
        decimalSeperator: ',',
        thousandSeperator: '.',
        moneyFormat: '%v%s',
        currencySymbol: {
            EUR: '€',
            YEN: '¥',
            SGD: 'S$',
            USD: '$',
            GBP: '£',
        },
    },
    ReturningPage: {
        title: 'Vielen Dank',
        mainText:
            'Vielen Dank fürs Einrichten des Zahlungsmittels. Bitte <strong>schließen Sie dieses Fenster</strong> und kehren Sie zur WeWash-App zurück.',
        buttonText: 'Weiter',
    },
    PartnersOverview: {
        title: 'Verwaltungsbereiche',
        titlePartnerByLocation: 'Suche Verwaltungsbereich über Location ID',
        confirm: 'Zum Bereich',
        newPartner: 'Neuen Verwaltungsbereich hinzufügen',
        titlePartnerId: 'Partner ID / Kundennr.',
        titleContact: 'Ansprechpartner',
        titleCompany: 'Firma',
        titleCreditNoteRecipient: 'Gutschriftenempfänger',
        titleAddress: 'Firmenadresse',
        titleButton: '',
        postitText:
            '<p>Unter einem Verwaltungsbereich können ein oder mehrere Objekte und Waschräume verwaltet werden, welche identische Ansprechpartner und Rechnungsdaten besitzen.</p><p>Weichen diese Daten Ihrer Objekte voneinander ab, wird die Anlage einzelner Verwaltungsbereiche erforderlich.</p>',
        titleCardTitle: 'Bereichsübersicht',
        titleCardSubtitle: '',
        partnerFilterHint:
            'Filtern z. B. nach Gutschriftenempfänger, Firmenname, PLZ, ...',
        partnerFilterHintFS:
            'Filtern z. B. nach Gutschriftenempfänger, PLZ, Partner ID, ...',
        searchByLocationId: 'Suchen nach Location ID',
    },
    Downloads: {
        userInformation: 'Infomaterial für Nutzer',
        laundryRoomInformation: 'Infomaterial für Waschräume',
        partnerBoardInstructions: 'Anleitung Partner Board',
        name: 'Name',
        language: 'Sprache',
        postIt: {
            text1: 'Hier finden Sie das digitale Infomaterial für Ihre Nutzer und Waschräume.',
            text2: 'Gerne senden wir Ihnen die gedruckte Version per Post zu. Wenden Sie sich hierfür bitte an installation@we-wash.com.',
        },
    },
    PartnerUsageData: {
        listTitle: 'Liste',
        configurationTitle: 'Automatisches Abonnement',
    },
    UsageDataSubscriptionConfigurationForm: {
        genericError: 'Bitte überprüfen Sie Ihre Eingaben.',
        subscriptionsIntro:
            'Sie können automatisch eine CSV-Datei mit den monatlichen Nutzungsdaten erhalten. Bitte geben Sie dazu die E-Mail-Adresse des Empfängers an. Wählen Sie bitte, ob Sie einen Abschlussbericht am Ende des Monats oder tägliche Updates beziehen wollen.',
        subscriptionType: 'Häufigkeit der E-Mails',
        subscriptionTypes: {
            NONE: 'nie',
            MONTHLY: 'monatlich',
            CUMULATIVE_DAILY: 'täglich',
        },
        emailAddress: 'E-Mail Adresse',
        emailAddressError: 'Bitte geben Sie eine E-Mail Adresse ein.',
        reception: 'Rezeptions-Accounts',
        receptionError:
            'Please provide a comma-separated list of customer-ids - e. g. "400112233, 400223344"',
        housekeeping: 'Housekeeping-Accounts',
        housekeepingError:
            'Please provide a comma-separated list of customer-ids - e. g. "400112233, 400223344"',
    },
    DetailedUsageDataScreen: {
        loading: 'Daten werden geladen...',
        error: 'Fehler.',
        title: 'Nutzungsdaten',
        months: {
            1: 'Januar',
            2: 'Februar',
            3: 'März',
            4: 'April',
            5: 'Mai',
            6: 'Juni',
            7: 'Juli',
            8: 'August',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'Dezember',
        },
    },
    UsageReportTable: {
        headerTime: 'Zeitpunkt',
        headerAppliance: 'Maschine',
        headerLaundryRoom: 'Waschraum',
        headerPrice: 'Preis',
        headerBookingType: 'Booking Type',
        empty: 'Keine Nutzungsdaten vorhanden.',
        download: 'Download als CSV',
    },
    UsageOverviewChart: {
        months: {
            1: 'Januar',
            2: 'Februar',
            3: 'März',
            4: 'April',
            5: 'Mai',
            6: 'Juni',
            7: 'Juli',
            8: 'August',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'Dezember',
        },
    },
    OAuthPropertyLinkForm: {
        propertyManagementSystemProviderDescription:
            'Property Management System Provider',
        hotelCodeDescription: 'Hotel Code',
        hotelCodeLinkDescription: 'Login Link für Hotelgäste',
        enterEmailForOAuthLandingPageRequest:
            'E-Mail für Property-Link eingeben:',
        requestOAuthLandingPageForLocation: 'Property Link Code generieren',
        requestNewOAuthLandingPageForLocation:
            'Neuen Property Link Code generieren',
        propertyLinkUrlDescription: 'Property-Link URL',
        propertyLinkCodeDescription: 'Property-Link Code',
        copyPropertyLinkUrl: 'Kopieren',
        apaleoStepsTitle: 'Mit Apaleo verbinden',
        apaleoStepsLocationExists: 'Waschraum angelegt',
        apaleoStepsCreateLink: 'Link für Partner angelegt',
        apaleoStepsWaitForPartner: 'Partner gewährt Zugang zu Apaleo',
        apaleoStepsAssignProperty: 'Apaleo-Property zugewiesen',
        descriptionWaitForPartner:
            'Mit dem Link kann der Zugriff auf die Apaleo-Resourcen gewährt werden. Um Updates zu sehen, muss die Seite neu geladen werden.',
        linkToSelectProperty: 'Apaleo Property auswählen',
    },
    LocationApaleoPropertyScreen: {
        title: 'Apaleo Property',
        subtitle: 'auswählen',
        left1: 'WeWash mit',
        left2: 'Apaleo verbinden',
        cancel: 'Zurück',
        pages: 'Seite:',
    },
    LocationApaleoPropertyList: {
        propertyId: 'Property ID',
        name: 'Name',
        postalCode: 'PLZ',
        address: 'Adresse',
        linkButton: 'Verknüpfen',
    },
    ChangeEmailForm: {
        title: 'E-Mail-Adresse ändern',
        sideTitle: 'Account verwalten',
        cancel: 'abbrechen',
        activeRecordTitle: 'Login-Daten',
        expiredAt: 'Der Bestätigungslink ist gültig bis %s.',
        requestedEmail: 'Wechsel angefordert zu E-Mail-Adresse',
        currentEmail: 'Aktuelle E-Mail-Adresse',
        newEmailHeader: 'Neue E-Mail-Adresse',
        newEmailConfirmHeader: 'Neue E-Mail-Adresse bestätigen',
        requestButtonText: 'Änderung beauftragen',
        requestChangeButtonText: 'Änderungsanfrage anpassen',
        editButtonText: 'E-Mail-Adresse ändern',
        unknownError: 'Ein unerwarteter Fehler is aufgetreten',
        duplicateEmail: 'Eingegebene E-Mail-Adresse ist bereits vorhanden',
        invalidEmail: 'Eingegebene E-Mail Adresse ist nicht gültig',
        missingEmail: 'Keine E-Mail Adresse angegeben',
        success:
            'Wir haben eine E-Mail an die neue Adresse geschickt. Bitte folgen Sie den darin enthaltenen Anweisungen.',
    },
    ChangeEmailLandingPage: {
        title: 'Änderung der E-Mail-Adresse bestätigen',
        sideTitle: 'Änderungsauftrag bestätigen',
        changeEmail: 'Neue E-Mail-Adresse',
        currentEmail: 'Alte E-Mail-Adresse',
        confirmButtonText: 'Änderung bestätigen',
        reLogin: 'Weiter zum Login',
        notFound: 'E-Mail ändern',
        error: 'Ein Fehler ist aufgetreten',
        success: 'Änderung bestätigt',
    },
    LoginActivationScreen: {
        cardTitle: 'Account',
        cardSubtitle: 'aktivieren',
        title: 'Account aktivieren',
        textLoading: 'Überprüfung...',
        textExpired:
            'Dieser Aktivierungslink ist nicht mehr gültig. Bitte kontaktieren Sie installation@we-wash.com, um einen neuen Aktivierungslink zu erhalten.',
        textInfo:
            'Bitte erstellen Sie ein Passwort für Ihren Account. Danach können Sie sich mit Ihrer E-Mail-Adresse %s und diesem Passwort einloggen.',
        fieldPassword: 'Passwort',
        fieldPasswordError:
            'Bitte beachten Sie die Regeln für ein sicheres Passwort.',
        hintPassword:
            'Das Passwort muss aus mind. 8 Zeichen inkl. mind. 1 Sonderzeichen und 1 Zahl bestehen.',
        fieldRepeatPassword: 'Passwort Wiederholung',
        fieldRepeatPasswordError:
            'Die Passwörter unterscheiden sich. Bitte geben Sie das gleiche Passwort an.',
        submit: 'Aktivieren',
        submitInProgress: 'Aktivierung läuft...',
        genericError: 'Aktivierung hat nicht funktioniert.',
        termsAndCond1: 'Hiermit bestätige ich, dass ich die ',
        tac: 'Nutzungsbedingungen',
        tacUrlRoute: '/nutzungsbedingungen',
        pp: 'Datenschutzerklärung',
        ppUrlRoute: '/datenschutz',
        and: ' und die ',
        termsAndCond2: ' gelesen und akzeptiert habe.',
        accept_tacError:
            'Bitte bestätigen Sie, dass Sie die Nutzungsbedingungen und die Datenschutzerklärung gelesen und akzeptiert haben.',
    },
    VipLaundryRoomInfoCard: {
        title: 'Waschraum',
    },
    VipRemoveUserCard: {
        loading: 'Daten werden geladen...',
        remove: 'Wahlen',
        title: 'Nutzer welche reduzierte Preise verwenden',
        description:
            'Sie können bestehende Nutzer einsehen und einzelne Einträge aus der Liste entfernen. ',
        errorLoading: 'Probleme beim Laden der Daten',
        listHasMore: '... und %s weitere',
        noUsers: 'Bisher keine Nutzer',
        removeAction: 'Entfernen',
        selectedCount: '%s Nutzer zum Entfernen ausgewählt',
    },
    SelectLocationPricing: {
        title: 'Waschraum auswählen',
        priceTitle: 'Preise verwalten',
        description: '',
        no_locations: 'Es konnten keine Waschräume gefunden werden.',
        name: 'Name',
        address: 'Address',
        prices: 'Prices',
        washing: 'Washing',
        drying: 'Drying',
    },
    LocationPricing: {
        cancel: 'Abbrechen',
        title: 'Preise verwalten',
        washing: 'Waschen',
        drying: 'Trocknen',
    },
    LaundryRoomPricesCard: {
        washing: 'Preis für Waschen (in %s)',
        drying: 'Preis für Trocknen (in %s)',
        washingVip: 'Reduzierter Preis für Waschen (in %s)',
        dryingVip: 'Reduzierter Preis für Trocknen (in %s)',
        loading: 'Preise werden geladen...',
        loadingError: 'Probleme beim Datenladen.',
        error: 'Geben Sie bitte den Preis ohne die Währung ein.',
        title: 'Preise verwalten',
        useVipPrices: 'Reduzierte Preise konfigurieren',
        vipPricesKeep: 'Reduzierte Preise unverändert lassen',
        vipPricesChange: 'Reduzierte Preise ändern',
        vipPricesConfigure: 'Reduzierte Preise konfigurieren',
        vipPricesDisable: 'Reduzierte Preise deaktivieren',
        vipPricesDoNotConfigure: 'Keine reduzierten Preise konfigurieren',
        vipPricesKeepHint:
            'Nur die normalen Preise werden geändert. Die reduzierten Preise bleiben wie bisher.',
        vipPricesChangeHint:
            'Die reduzierten Preise werden mit dieser Preisänderung angepasst.',
        vipPricesDisableHint:
            'Die reduzierten Preise werden mit dieser Preisänderung deaktiviert.',
        vipPricesDoNotConfigureHint: 'Es werden nur normale Preise verwendet.',
        configureVipSettings: 'Reduzierte Preise verwalten',
        boxTitleCurrent: 'Aktuelle Preise',
        boxTitleFuture: 'Neue Preise',
        boxInfoNow: 'Heute',
        boxInfoFuture: 'Ab %s',
        scheduledInfoText:
            'Bitte denken Sie daran, eventuelle Preisaushänge im Waschraum oder an anderen Stellen ' +
            'zu aktualisieren, oder bei dieser Gelegenheit die Preisaushänge zu entfernen.',
        scheduleLabel: 'Wann soll die Preisänderung wirksam werden?',
        scheduleHintImmediately: 'Die Preisänderung wird sofort wirksam.',
        scheduleHintDelayed:
            'Wir informieren die Nutzer in der App über die bevorstehende Preisänderung.',
        buttonRemove: 'Preisänderung zurücknehmen',
        buttonSave: 'Preisänderung übernehmen',
        genericError: 'Etwas ist schief gelaufen',
        pricesUnchangedError: 'Die Preise haben sich nicht geändert',
        costCalculatorAction:
            'Wir bieten Ihnen eine Hilfestellung zum Festlegen der Preise an. Klicken Sie hier um zum Nutzungspreis-Kalkulator zu kommen.',
        costCalculatorLink: 'https://we-wash.com/nutzungspreiskalkulator/',
    },
    SuggestedPriceIncreaseCard: {
        title: 'Vorgeschlagene Preisänderung',
        description: '',
        currentPrices: 'Aktuelle Preise',
        weSuggest: 'Wir schlagen die folgenden Preise vor',
        oldPriceWash: 'Preis für Waschen',
        oldPriceDry: 'Preis für Trocknen',
        priceWash: 'Preis für Waschen (in %s)',
        priceDry: 'Preis für Trocknen (in %s)',
        schedule: 'Wann soll die Preisänderung wirksam werden?',
        hintImmediately: 'Die Preisänderung wird sofort wirksam.',
        hintDelayed:
            'Wir informieren die Nutzer in der App über die bevorstehende Preisänderung.',
        btnAccept: 'Preisänderung übernehmen',
        btnReject: 'Ignorieren',
        btnGoToPricingScreen: 'Preise bearbeiten',
        genericError:
            'Etwas ist schief gelaufen. Bitte versuchen Sie es später nochmal.',
    },
    ScheduleTimeSelect: {
        IMMEDIATELY: 'Sofort',
        IN_SEVEN_DAYS: 'In 7 Tagen',
        FIRST_OF_NEXT_MONTH: 'Zum Monatsbeginn',
    },
    RolesAddUserCard: {
        title: 'Einladen',
        emailAddress: 'E-Mail Adresse',
        role: 'Rolle',
        subRole: 'Interner Accounttyp',
        paymentConfirmation:
            'Ich akzeptiere, dass die Kosten für Wasch- und Trockenzyklen über die monatlichen Gutschriften abgerechnet werden.',
        success: 'Einladung wurde erfolgreich verschickt',
        errors: {
            UNKNOWN_ERROR:
                'Etwas ist schief gelaufen. Bitte probieren Sie es erneut.',
            NO_LOCATIONS_EXIST_FOR_SETUP_PROCESS:
                'Es existiert kein Waschraum für diesen Verwaltungsbereich. Bitte erstellen Sie zunächst einen Waschraum.',
            USER_EMAIL_ALREADY_EXISTS:
                'Die angegebene E-Mail Adresse existiert bereits.',
            SETUP_PROCESS_EMAIL_AND_ROLE_NOT_UNIQUE:
                'Ein Nutzer mit dieser E-Mail Adresse wurde bereits für die selbe Rolle eingeladen. Falls Sie den Accounttyp eines internen Nutzeraccounts ändern wollen müssen sie zuerst den Account entfernen.',
            invalidEmail: 'Die angegebene E-Mail Adresse ist ungültig',
            duplicateEmail: 'Diese E-Mail ist bereits vergeben.',
            B2B_LAUNDRY_USAGE_NOT_ALLOWED:
                'Benutzer mit dieser Rolle können diesem Abrechnungsbereich nicht hinzugefügt werden.',
            B2B_LAUNDRY_USAGE_NOT_ALLOWED_IN_COUNTRY:
                'Diese Rolle ist in dieser Länderregion aktuell nicht verfügbar.',
        },
    },
    RolesInviteWrapper: {
        title: 'Einladen',
        back: 'Zurück zur Zugriffsverwaltung',
    },
    RolesInfoCard: {
        general:
            'Hier gewähren Sie Zugriff für diesen Verwaltungsbereich. Verfügbare Rollen:',
        laundryUserTitle: 'Interner Nutzeraccount',
        laundryUserBody1: 'Kann über die ',
        laundryUserBody2:
            'Maschinen buchen. Abrechnung erfolgt über monatliche Gutschriften:',
        laundryUserSubRole1: 'Kommerziell (Normalpreis) - Verkauf an Dritte',
        laundryUserSubRole2a: 'Intern (reduzierter Preis)',
        laundryUserSubRole2b: '- Für internen Gebrauch',
        laundryUserSubRole2Explanation:
            'Reduzierte Preise können pro Waschraum konfiguriert werden',
        userAppLinkText: 'WeWash App',
    },
    UserActivationOverview: {
        tableTitle: 'Zugriffsverwaltung',
        userEmailHeader: 'E-Mail-Adresse',
        roleHeader: 'Rolle',
        statusHeader: 'Status',
        toAddUserForm: 'Einladen',
        roleTranslations: {
            TECHNICIAN: 'Techniker',
            B2B_LAUNDRY_USAGE: 'Interner Nutzeraccount',
        },
        subRoleTranslations: {
            RECEPTIONIST: 'Kommerziell',
            INTERNAL: 'Intern',
            HOUSEKEEPING: 'Kostenfrei (Zusatzvereinbarung)',
        },
        statusTranslations: {
            ERROR: 'Fehler',
            COMPLETED: 'Aktiv',
            IN_PROGRESS: 'Einladung versendet',
        },
        actionTranslations: {
            REVORKE: 'Zugangsberechtigung aufheben',
        },
        confirmDeleteRoleMessage:
            'Möchten Sie die Einladung von %s zurücknehmen?',
    },
    PartnerInvoices: {
        title: 'Rechnungen',
        description: 'Übersicht der Rechnungen',
        noInvoices: 'Keine Rechnungen gefunden.',
        names: {
            UNKNOWN: 'Rechnung',
            MINIMUM_USAGE: 'Mindestnutzung',
        },
        accountingStatus: {
            INTERNAL: '',
            FILED: '',
            CANCELED: 'Storniert',
            CORRECTED: 'Storniert',
            CUSTOM_FILED: '',
        },
    },
    OperationalContactsList: {
        title: 'Ansprechpartner',
        objectsTitle: 'Objekte',
        columns: {
            name: 'Name',
            role: 'Funktion',
            email: 'E-Mail',
            phone1: 'Telefon 1',
            phone2: 'Telefon 2',
        },
        noContacts: 'Keine Ansprechpartner hinterlegt.',
        errorLoading: 'Fehler beim Laden der Ansprechpartner.',
        createContact: 'Ansprechpartner hinzufügen',
    },
    OperationalContactRoleNames: {
        JANITOR: 'Hausmeister',
        RECEPTION: 'Rezeption',
        SERVICE_PROVIDER: 'Dienstleister',
        ADMINISTRATIVE_CONTACT: 'Administrativer Ansprechpartner',
        OPERATIONAL_CONTACT: 'Operativer Ansprechpartner',
        PROPERTY_MANAGEMENT: 'Hausverwaltung',
        OTHER: 'Andere',
    },
    OperationalContactSalutationNames: {
        undefined: '-- Bitte wählen Sie --',
        FEMALE: 'Frau',
        MALE: 'Herr',
        UNSPECIFIED: 'Divers/nicht angegeben',
    },
    OperationalContactEdit: {
        title: 'Ansprechpartner ändern',
        back: 'Zurück',
        actionSave: 'Speichern',
        actionCreate: 'Hinzufügen',
        labelName: 'Name*',
        errorName: 'Geben Sie bitte einen Namen an.',
        labelFirstName: 'Vorname',
        labelSalutation: 'Anrede',
        labelEmail: 'E-Mail Adresse',
        labelPhone1: 'Telefon 1',
        labelPhone2: 'Telefon 2',
        errorContactEmailOrPhone:
            'Geben Sie bitte eine E-Mail Adresse oder eine Telefonnummer an.',
        labelRole: 'Funktion*',
        changedNote: 'Zuletzt geändert am %s',
        errorTags: {
            UNKNOWN: 'Ein Fehler ist aufgetreten.',
            MISSING_CONTACT_INFO:
                'Bitte geben Sie eine E-Mail Adresse oder eine Telefonnummer an.',
        },
        delete: 'Löschen',
        deleteModal: {
            title: 'Ansprechpartner löschen?',
            description:
                'Mit dem Löschen des Ansprechpartners wird dieser von allen zugewiesenen Objekten entfernt. Wir werden diese Person nicht mehr kontaktieren.',
            confirm: 'Löschen',
            cancel: 'Abbrechen',
        },
    },
    OperationalContactAssign: {
        title: 'Objekten zuweisen',
        back: 'Zurück',
        errorAssign: 'Ein Fehler ist aufgetreten.',
        street: 'Straße',
        city: 'Stadt',
        countLocations: 'Waschräume',
        checkAll: 'Alle wählen',
        checkOneAria: 'Dieses Objekt auswählen',
    },
    OperationalContactCreate: {
        title: 'Ansprechpartner hinzufügen',
        description:
            'Bitte hinterlegen Sie für jedes Ihrer Objekte einen operativen Ansprechpartner. Diesen kontaktieren wir bei operativen Themen, z.B. wenn eine Maschine gewartet werden muss.',
        titleAssignments: 'Objektverantwortlichkeit zuweisen',
        descriptionAssignments:
            'Wählen Sie die Objekte aus, für die dieser Ansprechpartner verantwortlich ist.',
        back: 'Abbrechen',
        actionCreate: 'Hinzufügen',
        errorTags: {
            UNKNOWN: 'Ein Fehler ist aufgetreten.',
            MISSING_CONTACT_INFO:
                'Bitte geben Sie eine E-Mail Adresse oder eine Telefonnummer an.',
        },
    },
    MansionToOperationalContactAssign: {
        title: 'Ansprechpartner',
        errorAssign: 'Ein Fehler ist aufgetreten.',
        name: 'Name',
        contactInformation: 'Kontaktdaten',
        role: 'Funktion',
        actionCreate: 'Weiteren Ansprechpartner hinzufügen',
        checkAll: 'Alle auswählen',
        checkOneAria: 'Diesen Ansprechpartner auswählen',
    },
    LocationPhoneUserCard: {
        title: 'Telefonnutzer',
        description:
            'Sie können Telefonnutzer einrichten, indem Sie deren E-Mail und Telefonnummer eingeben.',
        error: 'Ein Fehler ist aufgetreten.',
        colEmail: 'E-Mail',
        colPhone: 'Telefon',
        removeTitle: 'Telefonnutzer entfernen',
        removeDescription:
            'Wollen Sie den Telefonnutzer, mit Nummer %s, wirklich entfernen?',
        removeConfirm: 'Entfernen',
        removeCancel: 'Zurück',
        errorRemove: 'Der Telefonnutzer konnte nicht entfernt werden.',
        buttonAdd: 'Telefonnutzer hinzufügen',
    },
    LocationPhoneUserAddForm: {
        title: 'Telefonnutzer hinzufügen',
        description:
            'Fügen Sie einen neuen Telefonnutzer hinzu, indem Sie eine E-Mail-Adresse oder eine Telefonnummer angeben.',
        fieldPhone: 'Telefonnummer',
        hintPhone: 'Format: +49 123 4567890',
        errorPhone: 'Bitte geben Sie eine gültige Telefonnummer an.',
        fieldEMail: 'E-Mail',
        errorEMail: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
        termsAndConditions0: 'Der Nutzer hat den ',
        termsAndConditions1: 'Nutzungsbestimmungen',
        termsAndConditions2: ' und der ',
        termsAndConditions3: 'Datenschutzerklärung',
        termsAndConditions4: ' zugestimmt.',
        termsAndConditionsLink: 'https://we-wash.com/de/agb/',
        privacyPolicyLink: 'https://we-wash.com/de/datenschutz/',
        errorTermsAndConditions:
            'Wir benötigen die Zustimmung des Nutzers zu den Nutzungsbestimmungen.',
        buttonAdd: 'Hinzufügen',
        buttonCancel: 'Abbrechen',
        errorGeneric: 'Ein Fehler ist aufgetreten.',
        errorEMailAlreadyUsed: 'Diese E-Mail-Adresse wird bereits verwendet.',
        errorPhoneAlreadyUsed: 'Diese Telefonnummer wird bereits verwendet.',
    },
} as const;
